import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatWorkflowtracker = createCustomElementWrapper('kat-workflowtracker', 'KatWorkflowtracker', {}, {
    'onClick': 'click',
});
